import { EPath } from "constants/path";
import { AuthProvider } from "contexts/AuthContext";
import { ToastProvider } from "contexts/ToastContext";
import AuthActionPage from "pages/AuthActionPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import LoginPage from "pages/LoginPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import SettingsResetPasswordPage from "pages/SettingsResetPasswordPage";
import { Route, Routes } from "react-router";
import NotFound from "routes/NotFound";
import ProtectedRoute from "routes/ProtectedRoute";
import routeConfig, { RouteConfig } from "routes/routeConfig";
import { CelleraThemeProvider } from "theme/CelleraThemeProvider";

const generateRoutes = (routes: RouteConfig[]) => {
  return routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={<ProtectedRoute route={route} />}
    />
  ));
};

function App() {
  return (
    <CelleraThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            {generateRoutes(routeConfig)}
            <Route path={EPath.LOGIN} element={<LoginPage />} />
            <Route
              path={EPath.FORGOT_PASSWORD}
              element={<ForgotPasswordPage />}
            />
            <Route
              path={EPath.RESET_PASSWORD}
              element={<ResetPasswordPage />}
            />
            <Route path={EPath.AUTH_ACTION} element={<AuthActionPage />} />
            <Route
              path={EPath.SETTINGS_RESET_PASSWORD}
              element={<SettingsResetPasswordPage />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </CelleraThemeProvider>
  );
}

export default App;
